// extracted by mini-css-extract-plugin
module.exports = {"videoBlock":"VideoBlock_videoBlock__2jlU4","video":"VideoBlock_video__2kx_v","deleteBtn":"VideoBlock_deleteBtn__3JH22"};